const initializedSections = new WeakSet();

async function loadRelated(section) {
  const list = section.querySelector('[data-duepa-recommendation-list]');
  if (!list) return;
  const allowed = new Set(section.dataset.fallbackIds.split('|').filter(Boolean));
  if (allowed.size === 0) return;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  try {
    const response = await fetch(section.dataset.recommendationsUrl, {
      signal: controller.signal,
      credentials: 'same-origin'
    });
    if (!response.ok) return;
    const html = await response.text();
    const fragment = new DOMParser().parseFromString(html, 'text/html');
    const template = fragment.querySelector('[data-duepa-native-recommendations]');
    if (!template) return;

    const current = [...list.children];
    const curated = current.filter(item => item.dataset.recommendationOrigin === 'curated');
    const fallback = current.filter(item => item.dataset.recommendationOrigin === 'fallback');
    const native = [...template.content.querySelectorAll('[data-recommendation-id]')]
      .filter(item => allowed.has(item.dataset.recommendationId));
    if (native.length === 0) return;

    const chosen = [];
    const seen = new Set([section.dataset.productId]);
    for (const item of [...curated, ...native, ...fallback]) {
      const id = item.dataset.recommendationId;
      if (!id || seen.has(id)) continue;
      seen.add(id);
      chosen.push(item);
      if (chosen.length === 4) break;
    }
    if (chosen.length > 0) list.replaceChildren(...chosen);
  } catch {
    return;
  } finally {
    clearTimeout(timeout);
  }
}

function initializeRecommendations(root = document) {
  const sections = root.matches?.('[data-duepa-recommendations]')
    ? [root]
    : root.querySelectorAll('[data-duepa-recommendations]');
  for (const section of sections) {
    if (initializedSections.has(section)) continue;
    initializedSections.add(section);
    loadRelated(section);
  }
}

initializeRecommendations();
document.addEventListener('shopify:section:load', event => initializeRecommendations(event.target));
